import type { PublicSlotKey } from '@/apilib';
import type { WixCodeWorkspaceApi } from './api';

export const WixCodeWorkspaceApiKey: PublicSlotKey<WixCodeWorkspaceApi> = {
  name: 'WixCodeWorkspaceApi',
  public: true,
};
